// extracted by mini-css-extract-plugin
export var hideEditor = "_s6-2";
export var infoIcon = "_s6-3";
export var label = "_s6-1";
export var labelContainer = "_s6-0";
export var readonlyText = "_s6-4";